import cx from 'classnames';
import { ReactNode } from 'react';

import styles from './CardBase.module.less';

interface Props {
  className?: string;
  children: ReactNode;
}

export const CardBase = (props: Props) => (
  <div className={cx(styles.root, props.className)}>{props.children}</div>
);
